import { GRAMMAR_ITEM_POOLS } from '@repo/config';
import { z } from 'zod';
import { grammarItemSchema } from './grammar-item-schema';
import { grammarPointSchema } from './grammar-point-schema';

const lessonGrammarItemsSchema = z
  .array(grammarItemSchema)
  .min(20)
  .refine((items) => items.every(({ pool }) => pool === GRAMMAR_ITEM_POOLS[0]), {
    message: 'All lesson items must use the lesson pool',
  });

const examGrammarItemsSchema = z
  .array(grammarItemSchema)
  .min(8)
  .refine((items) => items.every(({ pool }) => pool === GRAMMAR_ITEM_POOLS[1]), {
    message: 'All exam items must use the exam pool',
  });

const grammarCurriculumPointSchema = z.object({
  point: grammarPointSchema,
  items: lessonGrammarItemsSchema,
  examItems: examGrammarItemsSchema,
});

const grammarCurriculumBatchSchemaDefinition = z.object({
  points: z.array(grammarCurriculumPointSchema),
});

export const grammarCurriculumBatchSchema: typeof grammarCurriculumBatchSchemaDefinition =
  grammarCurriculumBatchSchemaDefinition;

export type IGrammarCurriculumBatch = z.infer<typeof grammarCurriculumBatchSchema>;
